// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PStockOutlinedSvg from "@fishx/icons-svg/es/asn/PStockOutlined";
import FishxIcon from '../components/FishxIcon';

var PStockOutlined = function PStockOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PStockOutlinedSvg
  }));
};

PStockOutlined.displayName = 'PStockOutlined';
export default React.forwardRef(PStockOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PStockOutlined.js
// module id = 3655
// module chunks = 0